module.exports = {"banks":{"0001":"BANCO INTERNACIONAL DEL PERU (INTERBANK)","0002":"BANCO BBVA PERU","0003":"BANCO BCP PERU","0004":"BANCO SCOTIABANK PERU","0005":"BANCO INTERAMERICANO DE FINANZAS","0006":"PICHINCHA","0007":"MIBANCO","0008":"BANCO DE LA NACION","0009":"BANCO DE COMERCIO","0010":"BANCO SANTANDER","0011":"CITIBANK DEL PERU"}}


//////////////////
// WEBPACK FOOTER
// ./src/views/finance/withdraw-methods/mulix-wd-methods/payretailers-options/PE.json
// module id = 838
// module chunks = 0